export const actions = {
    GET_CONFIG_REQUEST: "GET_CONFIG_REQUEST",
    GET_CONFIG_SUCCESS: "GET_CONFIG_SUCCESS",
    GET_CONFIG_FAILURE: "GET_CONFIG_FAILURE",
  };
  